export default {
  assign_to_myself: 'Назначить на себя',
  reassign: 'Назначить на пользователя',
  modal: {
    title: 'Назначить чат с {numbers}',
    description: 'Выберите пользователя',
    other_options: 'Другие опции',
    unassigned_title: 'Не назначен',
    unassigned_description: 'Любой пользователь может продолжить общение',
  },
  with: {
    title: 'Со',
    me: 'Мной',
  },
}
